import * as KatalMetrics from '@amzn/katal-metrics';
import { KatalMonitoringDriver, KatalMonitoringDriverOptions } from '@amzn/katal-monitoring-aws-driver';
import KatalMetricsDriverConsoleLogJson from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson';
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector';

const metricsConsoleErrorHandler = (err: Error) => console.error(err);

const makeMetricsDriver = (): KatalMetrics.MetricsDriver => {
    if (process.env.NODE_ENV === 'test') {
        const metricsDriver = new KatalMetricsDriverArrayCollector();
        //  Attach to global window object so tests can see it
        (window as any).metricsDriver = metricsDriver;
        return metricsDriver;
    } else if (process.env.NODE_ENV !== 'production') {
        return new KatalMetricsDriverConsoleLogJson();
    } else {
        // Use KatalMonitoringDriver to publish metrics to CloudWatch
        // Namespace: Katal/MyHRLiteUI/KatalReactApplication
        // Dimensions added via metricsHelper: stage, site_code, login_method
        const katalMonitoringUrl = 'https://5dgork5iy2.execute-api.us-west-2.amazonaws.com/prod/v1/monitoring';

        // Fail fast if URL wasn't injected at deploy time
        if (katalMonitoringUrl.includes('{{')) {
            console.error('KatalMonitoringUrl not injected - falling back to console logging');
            return new KatalMetricsDriverConsoleLogJson();
        }

        const monitoringConfig: KatalMonitoringDriverOptions = {
            url: katalMonitoringUrl,
            errorHandler: metricsConsoleErrorHandler,
        };
        return new KatalMonitoringDriver(monitoringConfig);
    }
};

const makePublisher = (): KatalMetrics.Publisher => {
    const metricsDriver = makeMetricsDriver();
    const initialMetricsContext = new KatalMetrics.Context.Builder()
        .withSite('MyHRLiteUI')
        .withServiceName('KatalReactApplication')
        .build();
    return new KatalMetrics.Publisher(
        metricsDriver,
        metricsConsoleErrorHandler,
        initialMetricsContext);
};

const initialMetricsPublisher = makePublisher();

export default initialMetricsPublisher;
